module.exports = __webpack_public_path__ + "static/media/undraw_progressbars.9ffc1b39.svg";